import { Container, ListGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Navbar1 from "../Navbar/Navbar";
import Footer from "../footer/Footer";

import "./Fuorimenu.css";
function Backoffice() {
  const { t } = useTranslation();

  return (
    <div>
      <Navbar1 />

      <Container className="mt-5">
        <h2 className="mt-5 mb-5 text-center" id="cartamenu">
          {" "}
          Menù
        </h2>

        <ListGroup style={{ maxWidth: "500px", marginInline: "auto", textAlign: "center" }} id="testo">
          {/* Render menu data with delete buttons */}
          <ListGroup.Item>
            <h3 className="mb-3 " style={{ background: "#baf4b5" }}>
              {t("antipasti")}
            </h3>
            <div className="menu">
              <div className="nome"> {t("antipasto1")}</div> <div className="prezzo">14€</div>
            </div>

            <div className="menu">
              <div className="nome"> {t("antipasto2")}</div> <div className="prezzo">8€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("antipasto3")}</div> <div className="prezzo">10€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("antipasto4")}</div> <div className="prezzo">13€</div>
            </div>
          </ListGroup.Item>
          <ListGroup.Item>
            <h3 className="mb-3 " style={{ background: "#baf4b5" }}>
              {t("primi")}
            </h3>
            <div className="menu">
              <div className="nome"> {t("primo1")}</div> <div className="prezzo">12€</div>
            </div>

            <div className="menu">
              <div className="nome"> {t("primo2")}</div> <div className="prezzo">13€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("primo3")}</div> <div className="prezzo">11€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("primo4")}</div> <div className="prezzo">13€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("primo5")}</div> <div className="prezzo">11€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("primo6")}</div> <div className="prezzo">13€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("primo7")}</div> <div className="prezzo">10€</div>
            </div>
          </ListGroup.Item>
          <ListGroup.Item>
            <h3 className="mb-3" style={{ background: "#baf4b5" }}>
              {t("secondi")}
            </h3>
            <div className="menu">
              <div className="nome"> {t("secondo1")}</div> <div className="prezzo">15€</div>
            </div>

            <div className="menu">
              <div className="nome"> {t("secondo2")}</div> <div className="prezzo">15€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("secondo3")}</div> <div className="prezzo">13€</div>
            </div>
            <div className="menu">
              <div className="nome">
                {" "}
                {t("secondo4")}
                <br></br>
                <i> {t("secondosp")}</i>
              </div>
              <br></br>
              <div className="prezzo">13€</div>
            </div>
          </ListGroup.Item>
          <ListGroup.Item>
            <h3 className="mb-3" style={{ background: "#baf4b5" }}>
              {t("contorni")}
            </h3>
            <div className="menu">
              <div className="nome"> {t("contorni1")}</div>
              <div className="prezzo">5€</div>
            </div>
            <div className="menu">
              <div className="nome">
                {t("contorni2")}
                <br /> <i> {t("contornosp")}</i>
              </div>
              <div className="prezzo">6€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("contorni3")}</div>
              <div className="prezzo">5€</div>
            </div>
            <div className="menu">
              <div className="nome"> {t("contorni4")}</div>
              <div className="prezzo">6€</div>
            </div>
          </ListGroup.Item>

          <ListGroup.Item style={{ marginBottom: "60px" }}>
            <h3 className="mb-3 " style={{ background: "#baf4b5" }}>
              {t("dessert")}
            </h3>
            <div className="menu">
              <div className="nome"> {t("dessert1")}</div> <div className="prezzo">6€</div>
            </div>

            <div className="menu">
              <div className="nome"> {t("dessert2")}</div> <div className="prezzo">4,5€</div>
            </div>
          </ListGroup.Item>
        </ListGroup>
      </Container>
      <Footer></Footer>
    </div>
  );
}

export default Backoffice;
